import { render, staticRenderFns } from "./ModalKasKecilUploadEc.vue?vue&type=template&id=2018950a&"
import script from "./ModalKasKecilUploadEc.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilUploadEc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports